<template>
    <div class="table_wrap">
        <el-table :data="pointData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  height="695"
        >
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                width="90"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column min-width="" label="아이디" prop="mb_id" class-name="text-center">
                <template slot-scope="scope">
                    <el-link class="dgm-link" @click="moveProfile(scope.row.mb_no)">
                        {{scope.row.mb_id}}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="닉네임" prop="mb_nick" class-name="text-center">
                <template slot-scope="scope">
                    <el-link class="dgm-link" @click="moveProfile(scope.row.mb_no)">
                        {{scope.row.mb_nick}}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="신청 금액" prop="d_deposit" class-name="text-center">
                <template slot-scope="scope">
                    <span>{{returnCommas(scope.row.d_deposit)}}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="신청일자" prop="d_apply" class-name="text-center">
                <template slot-scope="scope">
                    <span>{{returnDate(scope.row.d_apply)}}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="처리일자" prop="d_done" class-name="text-center">
                <template slot-scope="scope">
                    <span>{{returnDate(scope.row.d_done)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="충전취소" width="" class-name="text-center">
                <template slot-scope="scope">
                    <span v-if="scope.row.d_status == 0">
                    <el-button class="com_btn"
                               @click="applyStatus(scope.row.d_idx)"> 완료 </el-button>
                    <el-button class="com_del"
                               @click="cancelStatus(scope.row.d_idx)"> 취소 </el-button>
                    </span>
                    <span v-else-if="scope.row.d_status === 1">완료</span>
                    <span v-else-if="scope.row.d_status === 2">취소</span>
<!--                    <span v-if="scope.row.ExtraData[0].o_status === 100">충전취소완료</span>
                    <el-button class="com_btn" v-else-if="returnDifferenceDay(scope.row.created_at,7)"
                               @click="cancelCharge(scope.row.p_idx)"> 충전취소 </el-button>
                    <span v-else>-</span>-->
                </template>
            </el-table-column>
        </el-table>

    </div>

</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import {paymentType} from "@/service/pointService";
import util from "@/mixins/util";
import commonOptions from "@/mixins/commonOptions";
import EventBus from "@/utils/event-bus";
export default {
    name: "PointListDepositLayout",
    mixins: [dateMixins, alertMixins,commonOptions],
    components: {
    },
    inject: ['setPage','setFilter'],
    provide() {
        return{

        }
    },
    props: {
        pointType: '',
        pointData: {
            default: () => {
                return []
            }
        },
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
    },
    data() {
        return{

        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        returnDate(date = null) {
            if (!date) {
                return '-';
            }
            return this.$moment(date).format('YYYY-MM-DD HH:mm')
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        applyStatus(d_idx) {
            let params = {d_idx : d_idx};
            EventBus.$emit('apiLoading', true);
            try {
                this.$api.$point.acceptDeposit(params).then(res => res.Data.Result).then(res => {
                    console.log(res)
                    EventBus.$emit('apiLoading', false);
                    if(res.Info.type == 1) {
                        EventBus.$emit('getPointList')
                        this.errorAlert('변경되었습니다.')
                    }else{
                        this.errorAlert('변경에 실패하였습니다.')
                    }
                })
            }catch (e) {
                console.log(e);
            }
        },
        cancelStatus(d_idx) {
            let params = {d_idx : d_idx};
            EventBus.$emit('apiLoading', true);
            try {
                this.$api.$point.cancelDeposit(params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('apiLoading', false);
                    if(res.Info.type == 1) {
                        EventBus.$emit('getPointList')
                        this.errorAlert('변경되었습니다.')
                    }else{
                        this.errorAlert('변경에 실패하였습니다.')
                    }
                })
            }catch (e) {
                console.log(e);
            }
        },
        moveProfile(mb_no) {
            this.$router.push('/member/detail/'+mb_no)
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
